var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8285 5.17175C12.3906 6.73385 12.3906 9.26651 10.8285 10.8286M5.17161 10.8286C3.60952 9.26648 3.60952 6.73383 5.17161 5.17173M3.286 12.7142C0.6825 10.1107 0.6825 5.88963 3.286 3.28613M12.7141 3.28616C15.3176 5.88966 15.3176 10.1108 12.7141 12.7143M9.33337 8.00018C9.33337 8.73656 8.73642 9.33351 8.00004 9.33351C7.26366 9.33351 6.66671 8.73656 6.66671 8.00018C6.66671 7.2638 7.26366 6.66684 8.00004 6.66684C8.73642 6.66684 9.33337 7.2638 9.33337 8.00018Z",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrigger);
export default __webpack_public_path__ + "static/media/trigger.409e53a3567cbff066f5142b476eb3ef.svg";
export { ForwardRef as ReactComponent };